export function TypingDots() {
  return (
    <span class="typing" aria-label="Assistant is typing">
      <span class="typing-dot"></span>
      <span class="typing-dot"></span>
      <span class="typing-dot"></span>
    </span>
  );
}
